import request from "@/utils/request";

//我的消息-消息列表
export function listMsg(data) {
    return request({
        url: "/Personal/listMsg",
        method: "post",
        data
    });
}

//我的消息-消息详情
export function getMsgById(data) {
    return request({
        url: "/Personal/getMsgById",
        method: "post",
        data
    });
}
